import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import authReducer from './authSlice'
import productReducer from './productSlice';
import authReducer, { AuthState } from './authSlice';
import purchaseReducer from './purchaseSlice'; // Import the slice reducer
import setupReducer from './setupSlice';

const store = configureStore({
  reducer: {
    products: productReducer,
    auth: authReducer,
    purchase: purchaseReducer,
    setup: setupReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type { AuthState }; // Exporting it here to make sure TypeScript knows where to find it
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
